export var LOAD_TEST_ACTION;
(function (LOAD_TEST_ACTION) {
    LOAD_TEST_ACTION["ANSWER_SURVEY"] = "ANSWER_SURVEY";
})(LOAD_TEST_ACTION || (LOAD_TEST_ACTION = {}));
//# sourceMappingURL=loadTest.js.map